export const SERVER_HOST = 'https://dev.demo.lfs.rest/api/v3';
export const SERVER_HOST_QR = 'https://dev.demo.lfs.rest/api/v4/';

